import { AlertColor } from '@mui/material/Alert'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { ICampaign, ICampaignStatus } from '../../types/contentCreatorTypes'

export interface ICampaignSlice {
  status: string
  shouldOpen: boolean
  message: string | undefined
  severity: AlertColor | undefined
  campaigns: ICampaign[] | undefined
  selectedCampaign: ICampaign | undefined
  myBidCampaigns: ICampaign[] | undefined
}

const initialState: ICampaignSlice = {
  status: 'idle',
  shouldOpen: false,
  message: undefined,
  severity: undefined,
  campaigns: [
    {
      id: '1',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Brand Collaboration with XYZ',
      bidPrice: '$500',
      location: 'Los Angeles, CA',
      duration: '2 weeks',
      social: {
        instagram: '@xyzbrand',
        tiktok: '@xyzbrandtok',
        facebook: 'facebook.com/xyzbrand',
        youtube: 'youtube.com/xyzbrand',
      },
      status: ICampaignStatus.IN_PROGRESS,
    },
    {
      id: '2',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Fashion Campaign - Summer Vibes',
      bidPrice: '$800',
      location: 'New York, NY',
      duration: '1 month',
      social: {
        instagram: '@summervibes',
        tiktok: '@summerfashiontok',
      },
      status: ICampaignStatus.ACCEPTED,
    },
    {
      id: '3',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Tech Product Launch Promo',
      bidPrice: '$1200',
      location: 'San Francisco, CA',
      duration: '3 weeks',
      social: {
        youtube: 'youtube.com/techlaunch',
        facebook: 'facebook.com/techlaunch',
      },
      status: ICampaignStatus.REJECTED,
    },
    {
      id: '4',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Fitness Challenge Partnership',
      bidPrice: '$950',
      location: 'Miami, FL',
      duration: '10 days',
      social: {
        instagram: '@fitchallenge',
        tiktok: '@fitchallenge',
      },
      status: ICampaignStatus.REJECTED,
    },
    {
      id: '5',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Foodie Tour Collaboration',
      bidPrice: '$700',
      location: 'Austin, TX',
      duration: '1 week',
      social: {
        instagram: '@austinfoodtour',
        youtube: 'youtube.com/austinfood',
      },
      status: ICampaignStatus.ACCEPTED,
    },
  ],
  myBidCampaigns: [
    {
      id: '1',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Brand Collaboration with XYZ',
      bidPrice: '$500',
      location: 'Los Angeles, CA',
      duration: '2 weeks',
      social: {
        instagram: '@xyzbrand',
        tiktok: '@xyzbrandtok',
        facebook: 'facebook.com/xyzbrand',
        youtube: 'youtube.com/xyzbrand',
      },
      sentBidPrice: '500',
      status: ICampaignStatus.IN_PROGRESS,
    },
    {
      id: '2',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Fashion Campaign - Summer Vibes',
      bidPrice: '$800',
      location: 'New York, NY',
      duration: '1 month',
      social: {
        instagram: '@summervibes',
        tiktok: '@summerfashiontok',
      },
      sentBidPrice: '800',
      status: ICampaignStatus.ACCEPTED,
    },
    {
      id: '3',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Tech Product Launch Promo',
      bidPrice: '$1200',
      location: 'San Francisco, CA',
      duration: '3 weeks',
      social: {
        youtube: 'youtube.com/techlaunch',
        facebook: 'facebook.com/techlaunch',
      },
      sentBidPrice: '1200',
      status: ICampaignStatus.REJECTED,
    },
    {
      id: '4',
      imageUrl:
        'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
      title: 'Fitness Challenge Partnership',
      bidPrice: '$950',
      location: 'Miami, FL',
      duration: '10 days',
      social: {
        instagram: '@fitchallenge',
        tiktok: '@fitchallenge',
      },
      sentBidPrice: '950',
      status: ICampaignStatus.REJECTED,
    },
  ],
  selectedCampaign: {
    id: '1',
    imageUrl:
      'https://t3.ftcdn.net/jpg/02/91/75/60/360_F_291756079_bCZqEPpJ3gOhshjQpx8YeBR5RiTgDOSf.jpg',
    title: 'Brand Collaboration with XYZ',
    bidPrice: '$500',
    location: 'Los Angeles, CA',
    duration: '2 weeks',
    social: {
      instagram: '@xyzbrand',
      tiktok: '@xyzbrandtok',
      facebook: 'facebook.com/xyzbrand',
      youtube: 'youtube.com/xyzbrand',
    },
  },
}

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.shouldOpen = action.payload
    },
    setCampaign: (state, action: PayloadAction<ICampaign>) => {
      const { id } = action.payload

      if (!state.campaigns) return

      const index = state.campaigns.findIndex((c) => c.id === id)

      if (index >= 0) {
        if (state.selectedCampaign?.id === id) {
          state.selectedCampaign = action.payload
        }
        state.campaigns[index] = action.payload
      } else {
        state.campaigns.push(action.payload)
      }
    },
    setSelectedCampaign: (
      state,
      action: PayloadAction<ICampaign | undefined>,
    ) => {
      state.selectedCampaign = action.payload
    },

    clearData: () => initialState,
  },
})

export const selectIsLoading = (state: RootState): boolean =>
  state.campaign.status === 'loading'
export const selectShouldOpen = (state: RootState): boolean =>
  state.campaign.shouldOpen
export const selectMessage = (state: RootState): string | undefined =>
  state.campaign.message
export const selectSeverity = (state: RootState): AlertColor | undefined =>
  state.campaign.severity
export const selectCampaigns = (state: RootState): ICampaign[] | undefined =>
  state.campaign.campaigns
export const selectExploreSelectedCampaign = (
  state: RootState,
): ICampaign | undefined => state.campaign.selectedCampaign
export const selectMyBidCampaigns = (
  state: RootState,
): ICampaign[] | undefined => state.campaign.myBidCampaigns

export const { setOpen, setCampaign, setSelectedCampaign, clearData } =
  campaignSlice.actions

export default campaignSlice.reducer
